import React, { useState, useContext, useEffect } from "react";
import { Input, Row, Col } from "design-react-kit";
import CheckboxOption from "./CheckboxOption";

function InterventoSADComponent({ setFormData, formData }) {
  const [izDelegate, setIzDelegate] = useState(false);

  const handleChangeDelegato = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      delegato: {
        ...prevData.delegato,
        [name]: value,
      },
    }));
  };

  return (
    <>
      <div className="mb-4">
        <CheckboxOption
          formData={formData}
          setFormData={setFormData}
          title={"Altre misure di sostegno di cui il richiedente beneficia:"}
          options={[
            "Pro.vi.",
            "Patto di Cura",
            "Sostegno Familiare",
            "Cure domiciliari erogate con Buoni Servizio",
          ]}
          col={2}
        />
      </div>
      <div className="toggles">
        <label className="label active">
          <div className="row">
            <div className="col-5">
              <input
                id="pagamentoAnticipato"
                type="checkbox"
                checked={izDelegate ?? ""}
                onChange={(e) => (
                  setIzDelegate(!izDelegate),
                  setFormData((prev) => {
                    if (!izDelegate) {
                      return {
                        ...prev,
                        delegato: {},
                      };
                    } else {
                      const { delegato, ...rest } = prev;
                      return rest;
                    }
                  })
                )}
              />
              <span className="lever me-0"></span>
            </div>
            <div className="col-3 ps-0 text-start">C'è un delegato</div>
          </div>
        </label>
      </div>
      {izDelegate && (
        <>
          <Row form className="mb-2 mt-2">
            <Col md={6}>
              <Input
                id="firstNameDelegato"
                label="Nome delegato*"
                name="firstName"
                value={formData?.delegato?.firstName}
                onChange={handleChangeDelegato}
              />
            </Col>
            <Col md={6}>
              <Input
                label="Cognome delegato*"
                id="lastNameDelegato"
                name="lastName"
                value={formData?.delegato?.lastName}
                onChange={handleChangeDelegato}
              />
            </Col>
          </Row>

          <Row form className="mb-2">
            <Col md={4}>
              <Input
                label="Luogo nascita delegato*"
                id="birthPlaceDelegato"
                name="birthPlace"
                value={formData?.delegato?.birthPlace}
                onChange={handleChangeDelegato}
              />
            </Col>
            <Col md={4}>
              <Input
                label="Data nascita delegato*"
                type="date"
                max={"9999-12-31"}
                id="birthDateDelegato"
                name="birthDate"
                value={formData?.delegato?.birthDate ?? " "}
                onChange={handleChangeDelegato}
              />
            </Col>
            <Col md={4}>
              <div className="mt-n3 ml-4">
                <div className="small text-muted">
                  <strong>Sesso delegato*</strong>
                </div>
                <div className="cmp-card-radio mt-2">
                  <div className="row mb-2">
                    {" "}
                    <div className="col-4">
                      <div className="radio-body">
                        <input
                          id="sessoMDelegato"
                          name="gender"
                          value="M"
                          type="radio"
                          className="mr-2"
                          checked={formData?.delegato?.gender === "M"}
                          style={{ cursor: "pointer" }}
                          onChange={handleChangeDelegato}
                        />
                        <label
                          htmlFor="sessoMDelegato"
                          className="active"
                          style={{ cursor: "pointer" }}
                        >
                          <strong>M</strong>
                        </label>
                      </div>
                    </div>
                    <div className="col-4">
                      <div className="radio-body">
                        <input
                          type="radio"
                          id="sessoFDelegato"
                          name="gender"
                          value="F"
                          className="mr-2"
                          checked={formData?.delegato?.gender === "F"}
                          style={{ cursor: "pointer" }}
                          onChange={handleChangeDelegato}
                        />
                        <label
                          htmlFor="sessoFDelegato"
                          className="active"
                          style={{ cursor: "pointer" }}
                        >
                          <strong>F</strong>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          <Row form className="mb-2">
            <Col md={6}>
              <Input
                id="cityDelegato"
                name="city"
                label="Comune residenza delegato*"
                value={formData?.delegato?.city}
                onChange={handleChangeDelegato}
              />
            </Col>
            <Col md={3}>
              <Input
                id="capDelegato"
                name="cap"
                label="CAP*"
                value={formData?.delegato?.cap}
                onChange={handleChangeDelegato}
              />
            </Col>
            <Col md={3}>
              <Input
                id="countryDelegato"
                name="country"
                label="Prov.*"
                value={formData?.delegato?.country}
                onChange={handleChangeDelegato}
              />
            </Col>
          </Row>

          <Row form className="mb-2">
            <Col>
              <Input
                type="text"
                id="homeAddressDelegato"
                name="homeAddress"
                label="Via residenza delegato*"
                value={formData?.delegato?.homeAddress}
                onChange={handleChangeDelegato}
              />
            </Col>
          </Row>

          <Row form className="mb-2">
            <Col md={6}>
              <Input
                type="email"
                id="emailDelegato"
                name="email"
                label="Email delegato*"
                value={formData?.delegato?.email}
                onChange={handleChangeDelegato}
              />
            </Col>
            <Col md={6}>
              <Input
                type="tel"
                id="phoneNumberDelegato"
                name="phoneNumber"
                label="Tel./Cell. delegato*"
                value={formData?.delegato?.phoneNumber}
                onChange={handleChangeDelegato}
              />
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Input
                id="fiscalCodeDelegato"
                name="fiscalCode"
                label="Codice Fiscale delegato*"
                value={formData?.delegato?.fiscalCode}
                onChange={handleChangeDelegato}
              />
            </Col>
          </Row>
          <Row form className="mb-2">
            <Col md={12}>
              <label htmlFor="gradoDelegato" className="form-label">
                Grado delegato*
              </label>
              <select
                id="qualitaDelegato"
                name="qualita"
                className="form-control custom-textarea mb-3 mt-n1"
                value={formData?.delegato?.qualita || ""}
                onChange={handleChangeDelegato}
                required
              >
                <option value="">Seleziona il grado</option>
                <option value="FAMILIARE">FAMILIARE</option>
                <option value="AMMINISTRATORE DI SOSTEGNO">
                  AMMINISTRATORE DI SOSTEGNO
                </option>
                <option value="TUTORE">TUTORE</option>
                <option value="CURATORE">CURATORE</option>
              </select>
            </Col>
          </Row>
          {formData?.delegato?.qualita === "FAMILIARE" ? (
            <Row form className="mt-3">
              <Col md={1}></Col>
              <Col md={10}>
                <Input
                  id="gradoParentelaDelegato"
                  name="grado"
                  label="Grado di parentela delegato*"
                  value={formData?.delegato?.grado || ""}
                  onChange={handleChangeDelegato}
                />
              </Col>
            </Row>
          ) : (
            <>
              {formData?.delegato?.qualita && (
                <Row form className="mt-3">
                  <Col md={6}>
                    <Input
                      id="numeroDecretoDelegato"
                      name="numeroDecreto"
                      label="Numero del decreto delegato*"
                      value={formData?.delegato?.numeroDecreto || ""}
                      onChange={handleChangeDelegato}
                    />
                  </Col>
                  <Col md={6}>
                    <Input
                      id="annoDecretoDelegato"
                      name="annoDecreto"
                      label="Anno del decreto delegato*"
                      value={formData?.delegato?.annoDecreto || ""}
                      onChange={handleChangeDelegato}
                    />
                  </Col>
                </Row>
              )}
            </>
          )}
        </>
      )}
    </>
  );
}

export default InterventoSADComponent;
